/**
 * As revisões do perito na conferência final (E169.F1, GUS-113, ADR-0117 §3): as que valem para o
 * material desta versão (RP-04, RP-08, suprimento, contraprova, diligências), com quem decidiu e
 * quando, e as que faltam. A pendente segura a assinatura pela prontidão; aqui só se mostra.
 */
import { ptBR } from '@/i18n/pt-BR';
import type {
  ConferenciaFinalData,
  RevisaoPericialNaConferenciaData,
} from '@/lib/conferencia_final';
import { formatarDataHora } from '@/lib/trilha_format';

const t = ptBR.conferenciaFinal.revisoes;

function textoDa(r: RevisaoPericialNaConferenciaData): string {
  const quem =
    r.revisor && r.em
      ? t.porQuem.replace('{nome}', r.revisor).replace('{quando}', formatarDataHora(r.em))
      : t.semQuem;
  return t.registrada
    .replace('{codigo}', r.codigo ? `${r.codigo} · ` : '')
    .replace('{tipo}', t.tipo[r.tipo])
    .replace('{quem}', quem);
}

export function RevisoesDoPerito({ conferencia }: { conferencia: ConferenciaFinalData }) {
  const { revisoes_em_vigor: emVigor, revisoes_pendentes: pendentes } = conferencia;
  return (
    <section
      className="border border-border bg-surface p-sc-4"
      aria-labelledby="revisoes-do-perito"
      data-testid="revisoes-do-perito"
    >
      <h2 id="revisoes-do-perito" className="text-body-lg font-semibold text-fg">
        {t.titulo}
      </h2>
      {emVigor.length === 0 ? (
        <p className="mt-sc-2 text-body-sm text-fg-muted">{t.nenhuma}</p>
      ) : (
        <ul className="mt-sc-2 space-y-sc-1 text-body-sm text-fg">
          {emVigor.map((r, i) => (
            <li key={`${r.tipo}-${i}`}>{textoDa(r)}</li>
          ))}
        </ul>
      )}
      {pendentes.length > 0 ? (
        <div className="mt-sc-3" data-testid="revisoes-pendentes">
          <p className="text-body-sm font-medium text-warning-700">{t.pendentes}</p>
          <ul className="list-disc space-y-sc-1 pl-sc-6 text-body-sm text-fg">
            {pendentes.map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  );
}
